document.addEventListener(
  "DOMContentLoaded",
  () => {
    const url = "https://sonsie-serverless.vercel.app/api/sms-signup";

    // Newsletter teaser functionality
    const newsletterTeaser = document.getElementById('newsletter-teaser');
    const newsletterPopup = document.querySelector('.newsletter-popup');
    const teaserClose = document.querySelector('.newsletter-teaser__close');
    const popupClose = document.querySelector('.newsletter-popup__close');
    const popupVeil = document.querySelector('.newsletter-popup__veil');

    // Check if user has already seen/dismissed the newsletter
    const hasSeenNewsletter = localStorage.getItem('sonsie-newsletter');
    // const hasDismissedTeaser = localStorage.getItem('sonsie-teaser-dismissed');

    // Show teaser after 3 seconds if user hasn't seen newsletter or dismissed teaser
    if (hasSeenNewsletter != "true" && newsletterTeaser) {
      setTimeout(() => {
        newsletterTeaser.classList.add('show');
      }, 3000);
    }

    // Teaser click handler - show full popup
    if (newsletterTeaser) {
      newsletterTeaser.addEventListener('click', (e) => {
        if (!e.target.closest('.newsletter-teaser__close')) {
          newsletterTeaser.classList.remove('show');
          newsletterPopup.classList.add('active');
        }
      });
    }

    // // Teaser close handler
    // if (teaserClose) {
    //   teaserClose.addEventListener('click', (e) => {
    //     e.stopPropagation();
    //     newsletterTeaser.classList.remove('show');
    //     localStorage.setItem('sonsie-teaser-dismissed', 'true');
    //   });
    // }

    // Full popup close handlers
    if (popupClose) {
      popupClose.addEventListener('click', () => {
        newsletterPopup.classList.remove('active');
      });
    }

    if (popupVeil) {
      popupVeil.addEventListener('click', () => {
        newsletterPopup.classList.remove('active');
      });
    }

    const config = (body) => {
      return {
        body: JSON.stringify(body),
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
      };
    };

    document
      .querySelector(".newsletter-signup__form")
      .addEventListener("submit", async (e) => {
        e.preventDefault();
        const form = e.target;
        const listId = form.dataset.list;
        const email = form.email.value;
        const button = form.querySelector("button");

        button.innerText = "Submitting...";

        if (listId) {
          const resp = await fetch(url, config({ email, listId }));
          const response = await resp.json();

          form.parentElement
            .querySelector(".signup-success")
            .classList.remove("hidden");
          form.classList.add("hidden");
          localStorage.setItem("sonsie-newsletter", "true");
        }
      });

    const popup = document.querySelector(".newsletter-popup__form");

    if (popup) {
      popup.addEventListener("submit", async (e) => {
        e.preventDefault();
        const form = e.target;
        const listId = form.dataset.list;
        const button = form.querySelector("button");
        const buttonText = button.innerText;
        const email = form.email.value;
        const phone = form.phone.value;
        const fmtPhone = phone
          ? `${
              form.querySelector(".newsletter-popup__tel span").innerText
            }${phone}`
          : phone;

        button.innerText = "Submitting...";

        if (listId) {
          try {
            const resp = await fetch(
              url,
              config({ email, phone: fmtPhone, listId })
            );
            const response = await resp.json();
            const parent = form.parentElement;
            const desc = parent.querySelector("p");
            const title = parent.querySelector("h2");

            title.innerText = title.dataset.successText;
            desc.style.display = "none";
            form.style.display = "none";

            localStorage.setItem("sonsie-newsletter", "true");
            
            // Hide teaser if it's showing
            if (newsletterTeaser) {
              newsletterTeaser.classList.remove('show');
            }
          } catch (e) {
            console.log(e.message);
          }
        }
      });
    }
  },
  false
);
